<template>
  <div>
    <tablita
      :cols="columnasVisibles"
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @ver_formulario_pcc="verFormularioPcc($event)"
      @ver_historial_formulario_pcc="verHistorialFormularioPcc($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar"
      :seleccionable="modoSeleccion"
      @seleccion-cambio="onSeleccionCambio"
    >
      <template v-slot:adicional>
        <button class="btn btn-sm btn-info" @click="toggleModoSeleccion">
          <i class="fas fa-check-square"></i>
          {{ modoSeleccion ? "Cancelar Selección" : "Descarga Masiva" }}
        </button>
        <button
          v-if="modoSeleccion && seleccionados.length > 0"
          class="btn btn-sm btn-success ml-2"
          :disabled="descargandoZip"
          @click="descargarZip"
        >
          <i class="fas fa-file-archive"></i>
          {{ descargandoZip ? "Descargando..." : `Descargar Seleccionados (${seleccionados.length})` }}
        </button>
      </template>
    </tablita>

    <!-- Modal Formulario PCC -->
    <div class="modal fade pcc-modal" id="modalPCC1" tabindex="-1" role="dialog"
        aria-labelledby="formularioPccModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div class="modal-content pcc-modal-content">

                <FormularioPCCHistorial
        v-if="formulario_pcc"
        :formulario="formulario_pcc"
        :historial="formulario_pcc.historiales"
        :guias="[]"
    />

            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Tabla from "../../components/Tabla/Tabla";
import FormularioPCCHistorial from "./FormularioPCCHistorial.vue";
import Swal from "sweetalert2";

export default {
  data: () => ({
    /*
     * Descarga masiva
     */
    modoSeleccion: false,
    seleccionados: [],
    descargandoZip: false,

    columnas: [
      {
        key: "id",
        label: "ID",
        busqueda: "",
        tipo: "number",
        searchable: true,
        path: "id",
      },
      {
        key: "created_at",
        label: "Fecha Creación",
        busqueda: "",
        tipo: "datetime",
        searchable: true,
        path: "created_at",
      },
      {
        key: "folio",
        label: "Folio",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "folio",
      },
      {
        key: "numero_guia",
        label: "Guia(s)",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "numero_guia",
      },
      {
        key: "cantidad_bins",
        label: "Cantidad Bins",
        busqueda: "",
        tipo: "number",
        searchable: false,
        path: "cantidad_bins",
      },
      {
        key: "romanero",
        label: "Romanero",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "romanero_nombre",
      },
      {
        key: "jefe_trazabilidad",
        label: "Jefe Trazabilidad",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "jefe_trazabilidad_nombre",
      },
      {
        key: "jefe_pac",
        label: "Jefe PAC",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "jefe_pac_nombre",
      },
      
      
    ],

    lista: [],
    links: [],

    /*
     * Formulario seleccionado
     */
    formulario_pcc: null,

    configuracion_tabla: {
      titulo: "Listado de Formularios PCC",
      btn_nuevo: false,
    },

    pagina_actual: "",
  }),

  mounted() {
    /*
     * Inicializamos la tabla
     */
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });

    /*
     * Recuperar filtros guardados
     */
    let storage = localStorage.getItem(this.path);

    if (storage) {
      storage = JSON.parse(storage);

      this.columnas.forEach((col) => {
        const columnaGuardada = storage.columnas.find(
          (c) => c.key == col.key
        );

        if (columnaGuardada) {
          col.busqueda = columnaGuardada.val;
        }
      });
    }

    /*
     * Cargar listado inicial
     */
    this.$emit("cargar");
  },

  methods: {

    /*
     * Descarga masiva: activa/desactiva el modo selección de filas
     */
    toggleModoSeleccion() {
      this.modoSeleccion = !this.modoSeleccion;
    },

    /*
     * Recibe los ids seleccionados desde la tabla
     */
    onSeleccionCambio(ids) {
      this.seleccionados = ids;
    },

    /*
     * Descarga el zip con los PDF de los formularios seleccionados
     */
    async descargarZip() {
      this.descargandoZip = true;

      try {
        const response = await this.axios.post(
          `${this.api}/formularios-pcc/descargar-zip`,
          { ids: this.seleccionados },
          { headers: this.cabeceras_json.headers, responseType: "blob" }
        );

        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/zip" })
        );

        const disposition = response.headers["content-disposition"] || "";
        const match = disposition.match(/filename="?([^"]+)"?/);
        const nombreArchivo = match ? match[1] : "Formularios_PCC.zip";

        const link = document.createElement("a");
        link.href = url;
        link.download = nombreArchivo;
        link.click();
        window.URL.revokeObjectURL(url);

        this.modoSeleccion = false;
      } catch (error) {
        console.error("Error al descargar el zip de formularios PCC:", error);

        let mensaje = "No se pudo generar la descarga masiva.";
        if (error.response && error.response.data instanceof Blob) {
          const texto = await error.response.data.text();
          try {
            const json = JSON.parse(texto);
            mensaje = json.message || mensaje;
          } catch (e) {
            // el cuerpo del error no era JSON, se deja el mensaje genérico
          }
        }
        Swal.fire({ icon: "error", title: "Error", text: mensaje });
      } finally {
        this.descargandoZip = false;
      }
    },

    /*
     * Abrir historial del formulario PCC
     */
    async verHistorialFormularioPcc(evento) {

        this.formulario_pcc = evento.item

      $("#modalPCC1").modal("show");
    },

    /*
     * Abrir pdf del formulario PCC
     */
    async verFormularioPcc(evento) {
      const url = `${this.api}/formulario/pcc/${evento.item.id}`;

            const ventana = window.open(url, '_blank');

            if (!ventana) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Ventana bloqueada',
                    text: 'El navegador bloqueó la ventana del PDF. Permite las ventanas emergentes para este sitio e inténtalo de nuevo.',
                });
            }
    },

    /*
     * Limpiar filtros y recargar
     */
    refrescar() {
      localStorage.removeItem(this.path);

      this.columnas.forEach((c) => {

        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });

      this.$emit("cargar");
    },

    /*
     * Carga inicial y filtros
     */
    async cargar($event) {
      this.$emit("spinner", true);

      this.pagina_actual =
        `${this.api}/formularios-pcc${$event}`;

      this.lista = [];

      try {

        const res = await this.axios.get(
          this.pagina_actual,
          this.cabeceras_json
        );

        this.lista = res.data.data.data;
        this.links = res.data.data.links;

        this.inicializar_tabla({
          columnas: this.columnasVisibles,
          lista: this.lista,
          links: this.links,
          botones: this.botones,
          botones_restringidos: [],
        });

        this.$emit(
          "generar",
          this.columnasVisibles,
          this.lista
        );

      } catch (error) {

        console.error(
          "Error al cargar formularios PCC:",
          error
        );

      } finally {

        this.$emit("spinner", false);
      }
    },

    /*
     * Cargar una página desde la paginación
     */
    async cargar_url(url) {

      if (!url) {
        return;
      }

      this.$emit("spinner", true);

      this.pagina_actual = url;

      try {

        const res = await this.axios.get(
          url,
          this.cabeceras_json
        );

        this.lista = res.data.data.data;
        this.links = res.data.data.links;

        this.setear_lista({
          lista: this.lista,
          links: this.links,
        });

      } catch (error) {

        console.error(
          "Error al cargar página de formularios PCC:",
          error
        );

      } finally {

        this.$emit("spinner", false);
      }
    },

    ...mapActions([
      "inicializar_tabla",
      "setear_lista",
    ]),
  },

  components: {
    tablita: Tabla,
    FormularioPCCHistorial,
  },

  computed: {

    ...mapState([
      "api",
      "cabeceras_json",
      "roles_rom",
    ]),

    /*
     * Solo el rol ROMANA_ADMIN puede ver la columna ID
     */
    esAdminRomana() {
      return (this.roles_rom || []).some((r) => r.name === "ROMANA_ADMIN");
    },

    /*
     * Columnas visibles según el rol del usuario
     */
    columnasVisibles() {
      if (this.esAdminRomana) {
        return this.columnas;
      }
      return this.columnas.filter((c) => c.key !== "id");
    },

    /*
     * Botones de la tabla
     */
    botones() {
      return [
        {
          label: "PDF",
          clase: "btn-danger",
          evento: "ver_formulario_pcc",
          icono: "fas fa-file-alt",
        },
        {
          label: "Historial",
          clase: "btn-info",
          evento: "ver_historial_formulario_pcc",
          icono: "fas fa-history",

          /*
           * Si quieres que el botón siempre aparezca,
           * puedes eliminar esta condición.
           */
          condicion: "tiene_formulario_pcc",
        },
      ];
    },

    /*
     * Ruta actual para guardar filtros
     */
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>

<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>